export const STAR_RATINGS = ['1', '2', '3', '4', '5'] as const;
export const SHOW_PRESENTER_FEEDBACK_DURING_EVENT_OVERTIME_IN_MINUTES = 30;
